// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".splide__arrows .splide__arrow{background:rgba(0,0,0,.8);border-radius:0;height:100%;opacity:.5;width:28px}.splide__arrows .splide__arrow:hover{background:#000;opacity:.5}.splide__arrows .splide__arrow svg{fill:#fff;stroke:#fff}.splide__arrows .splide__arrow--prev{left:0}.splide__arrows .splide__arrow--next{right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
